/** Prepend a scheme so a bare host ("example.com") is still a valid href. */
export const ensureProtocol = (url: string): string =>
  /^https?:\/\//i.test(url) ? url : `https://${url}`;

/** Human-readable host for display ("https://www.example.com/x" → "example.com"). */
export const formatUrlHost = (url: string): string => {
  try {
    return new URL(ensureProtocol(url)).hostname.replace(/^www\./, "");
  } catch {
    return url;
  }
};
